import { render, staticRenderFns } from "./VisitMove.vue?vue&type=template&id=0bfbdc5f&scoped=true&"
import script from "./VisitMove.vue?vue&type=script&lang=ts&"
export * from "./VisitMove.vue?vue&type=script&lang=ts&"
import style0 from "./VisitMove.vue?vue&type=style&index=0&id=0bfbdc5f&lang=scss&scoped=true&"
import style1 from "./VisitMove.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfbdc5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VRow})
